import { render, staticRenderFns } from "./SearchSharedFields.vue?vue&type=template&id=6e4a2811&scoped=true"
import script from "./SearchSharedFields.vue?vue&type=script&lang=js"
export * from "./SearchSharedFields.vue?vue&type=script&lang=js"
import style0 from "./SearchSharedFields.vue?vue&type=style&index=0&id=6e4a2811&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4a2811",
  null
  
)

export default component.exports